
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        departureType: 'PORT',
        destinationType: 'WAREHOUSE',
        name: null,
      },
      chargeItem: {},
      locationTypes: [
        { value: 'PORT', text: '港' },
        { value: 'WAREHOUSE', text: '纳入场所' },
      ],
      nameRules: [(v) => !!v || 'トラック名称 is required'],
      codeRules: [(v) => !!v || 'トラックタイプ is required'],
      volumeRules: [(v) => !!v || '最大積載C/W is required'],
    }
  },
  computed: {
    isWarehouseTransport() {
      return (
        this.form.specialId &&
        this.form.specialId.indexOf('WAREHOUSE_TRANSPORT') !== -1
      )
    },
  },
  methods: {
    save() {
      this.$http
        .post('pricings', {
          ...this.form,
          chargeItemId: this.chargeItem.id,
          pricingTypeId: `PRICING_TYPE-${this.$route.query.type}`,
        })
        .then(() => {
          this.$router.go(-1)
        })
        .catch((err) => this.$catch(err))
    },
    remove() {},
    chargeItemChanged(val) {
      this.form.chargeItemId = val.id
      this.form.chargeUnitId = null
    },
  },
  watch: {
    'form.departureType'(value) {
      if (value === 'PORT') {
        this.form.departureWarehouseId = null
      }
      if (value === 'WAREHOUSE') {
        this.form.departurePortCode = null
      }
    },
    'form.destinationType'(value) {
      if (this.isWarehouseTransport) return
      if (value === 'PORT') {
        this.form.destinationWarehouseId = null
      }
      if (value === 'WAREHOUSE') {
        this.form.destinationPortCode = null
      }
    },
  },
}
</script>
